export default __webpack_public_path__ + "static/media/one.40fe70cb.jpg";